import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './LobbyScreen.css';
import Button from '../ui/Button';
import PlayerList from './PlayerList';
import CardSelection from './CardSelection';
import { useGame } from '../../contexts/GameContext';
import { startGame } from '../../firebase/services';
import cards, { getCardIds } from '../../data/cards';

const LobbyScreen = () => {
  const { lobby, isHost, leaveGame } = useGame();
  const [selectedCards, setSelectedCards] = useState([]);
  const [isStarting, setIsStarting] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { lobbyCode } = useParams();
  
  // Watch for game start and redirect to game screen
  useEffect(() => {
    if (lobby && lobby.gameStarted) {
      console.log('Oyun başlatıldı, oyun ekranına yönlendiriliyor');
      navigate(`/game/${lobbyCode}`);
    }
  }, [lobby, lobbyCode, navigate]);

  if (!lobby) {
    return <div className="lobby-loading">Lobi yükleniyor...</div>;
  }

  const handleStartGame = async () => {
    if (!isHost) return;
    
    const neededCards = lobby.players.length + 3; // Players + 3 center cards
    
    if (selectedCards.length !== neededCards) {
      setError(`Oyunu başlatmak için ${neededCards} kart seçmelisiniz.`);
      return;
    }
    
    setError('');
    setIsStarting(true);
    
    try {
      await startGame(lobby.code, selectedCards);
    } catch (err) {
      console.error('Oyun başlatılırken hata:', err);
      setError(err.message || 'Oyun başlatılamadı.');
      setIsStarting(false);
    }
  };

  const handleCopyLobbyCode = () => {
    navigator.clipboard.writeText(lobby.code);
    // Could add a visual feedback here
  };

  return (
    <div className="lobby-screen">
      <div className="lobby-header">
        <h1>Tanrıların Şöleni</h1>
        <div className="lobby-info">
          <div className="lobby-code">
            <span>Lobi Kodu:</span>
            <div className="lobby-code-value" onClick={handleCopyLobbyCode}>
              <strong>{lobby.code}</strong>
              <span className="lobby-code-copy">Kopyala</span>
            </div>
          </div>
          <div className="lobby-players-count">
            <span>Oyuncular:</span>
            <strong>{lobby.players.length}</strong>
          </div>
          <Button 
            onClick={leaveGame} 
            variant="secondary" 
            size="small"
          >
            Lobiden Ayrıl
          </Button>
        </div>
      </div>
      
      <div className="lobby-content">
        <div className="lobby-players-section">
          <PlayerList />
        </div>
        
        {isHost && (
          <div className="lobby-settings-section">
            <h2 className="lobby-settings-title">Oyun Ayarları</h2>
            
            <CardSelection 
              selectedCards={selectedCards} 
              setSelectedCards={setSelectedCards} 
              requiredCount={lobby.players.length + 3}
            />
            
            {error && <div className="lobby-error">{error}</div>}
            
            <div className="lobby-start-game">
              <Button 
                onClick={handleStartGame} 
                fullWidth={true} 
                disabled={isStarting || selectedCards.length !== (lobby.players.length + 3)}
              >
                {isStarting ? 'Oyun Başlatılıyor...' : 'Oyunu Başlat'}
              </Button>
            </div>
          </div>
        )}
        
        {!isHost && (
          <div className="lobby-waiting">
            <div className="lobby-waiting-message">
              <h2>Oyun başlatılmayı bekliyor...</h2>
              <p>Lobi kurucusu oyunu başlattığında otomatik olarak başlayacak.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LobbyScreen;
